//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingPeriodController_create,
  Response$AdminBillingPeriodController_create$Status$201,
  ResponseContentType$AdminBillingPeriodController_create,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminBillingPeriodController_create = () =>
  useApiClientMutation<
    Params$AdminBillingPeriodController_create,
    Response$AdminBillingPeriodController_create$Status$201[ResponseContentType$AdminBillingPeriodController_create]
  >({ method: 'AdminBillingPeriodController_create' });
